import React, { createContext, useState, useEffect } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const profilesResponse = await fetch(`${process.env.PUBLIC_URL}/data/profiles.json`);
        const profilesData = await profilesResponse.json();

        const worksResponse = await fetch(`${process.env.PUBLIC_URL}/data/works.json`);
        const worksData = await worksResponse.json();

        const textsResponse = await fetch(`${process.env.PUBLIC_URL}/data/texts.json`);
        const textsData = await textsResponse.json();

        setData({ profiles: profilesData, works: worksData, texts: textsData[0], muted: false});
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const toggleMuted = () => {
    setData(prev => ({ ...prev, muted: !prev.muted }));
  };

  return (
    <DataContext.Provider value={{ data, loading, toggleMuted }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => React.useContext(DataContext);
